import axios from "axios";

export const API = "/api";

export const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("atr_token") || ""}`,
});

export const apiGet = (path) => axios.get(`${API}${path}`, { headers: authHeader() });
export const apiPost = (path, body) => axios.post(`${API}${path}`, body, { headers: authHeader() });
export const apiPut = (path, body) => axios.put(`${API}${path}`, body, { headers: authHeader() });
export const apiPatch = (path, body) => axios.patch(`${API}${path}`, body, { headers: authHeader() });

export const fmt = (n, d = 2) =>
  n == null ? "—" : Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export const decisionCls = (decision) =>
  decision === "TRADE"
    ? "text-buy border-buy/50 bg-buy/10"
    : decision === "WAIT"
    ? "text-warn border-warn/40 bg-warn/5"
    : "text-sell border-sell/40 bg-sell/5";
